window.odTheme = window.odTheme || {};

window.odTheme.AjaxCart = (function() {

  function AjaxCart(container){

    this.data = {
      isMember: window.odTheme.customer.isMember || window.odTheme.customer.membershipInCart,
      upsellAdded: false,
      displayUpsell: false,
      displayCallToActions: false,
      cartUpsellsData: window.odTheme.cart.reverse(),
      cartUpsells: [],
      cartCallToActions: [],
      cartUpsell: {},
      essentials: [],
      essentialProductData: [],
      cartGifts: window.odTheme && window.odTheme.cartGifts,
      cartCallToAction: {},
      freeSeedPromoEnabled: false,
      renewalPromotionEnabled: false,
      seedCount: 0,
      seedMaximum: 0,
      renewalProductCount: 0,
      renewalProductMaximum: 0,
      cartWidget: '[data-cart-widget]',
      clickedElementForExpanding: '[data-expand-button]',
      closeClass: 'closed',
      accessEnabled: {
        everyone: true,
        loggedOut: !window.odTheme.customer.loggedIn,
        loggedIn: window.odTheme.customer.loggedIn,
        notMember: !window.odTheme.customer.isMember && !window.odTheme.customer.membershipInCart,
        isMember: window.odTheme.customer.isMember || window.odTheme.customer.membershipInCart,
        expiringMember: window.odTheme.customer.isMember ? this.checkMembershipExpiration(window.odTheme.customer) : false,
        lapsedMember: !window.odTheme.customer.isMember && window.odTheme.customer.memberCode
      }
    }

    // Store essential product data once it's fetched
    this.essentialProductDataPromise = this.fetchProductData();

    this.init();
  }

  AjaxCart.prototype = window.odTheme.utils.extend({}, AjaxCart.prototype, {

    init: async function(pageHandle,tabContainer){
      var self = this;

      await self.getCart();

      document.addEventListener("cart:updated", function(e) {
        self.getCart();
        self.updateEssentialsAndSlider();
      });

      document.addEventListener("cart:reload", function(e) {
        self.getCart();
      });

      self.initAccordion();

      var tinybindContainer = document.querySelector('[data-cart-view]');
      tinybind.bind(tinybindContainer, {
        data: self.data,
        methods: {
          addToCart: function(event, binding) {
            self.addToCart(event, binding);
          },
          removeProductFromCart: function(event, binding) {
            var variantId = binding.item.variant_id;
            self.removeProductFromCart(variantId);
          },
          increaseQuantity: async function(event, binding){
            var variantId = binding.item.variant_id;
            var item = binding.item;
            binding.item.loading = true;
            self.increaseQuantity(variantId,item.quantity,item);
          },
          decreaseQuantity: function(event, binding){
            var variantId = binding.item.variant_id;
            var item = binding.item;
            binding.item.loading = true;
            self.decreaseQuantity(variantId,item.quantity,item);
          },
          selectUpsellProduct: function(event, binding){
          
            var selectedVariant = event.currentTarget.value;

            let upsell = self.data.cartUpsell;
            self.selectUpsellProduct(selectedVariant,upsell)
          },
          selectUpsellProductRadio: function(event, binding){
            var selectedVariant = event.currentTarget.previousElementSibling.value;
            let upsell = self.data.cartUpsell;
            self.selectUpsellProduct(selectedVariant,upsell)
          },
          closeUpsell: function(event, binding){
            self.data.displayUpsell = false;

            var expirationDate = new Date();
            expirationDate.setDate(expirationDate.getDate() + binding.data.cartUpsell.show_after);

            var storageObj = {value: "closed", timestamp: expirationDate.getTime()}
            sessionStorage.setItem(binding.data.cartUpsell.id, JSON.stringify(storageObj));
          }
        }
      });
    },

    fetchProductData: async function() {
      var self = this;
      var filteredEssentialsHandles = new Set(self.data.essentials);
      var essentialsHandles = Array.from(filteredEssentialsHandles);

      var fetchPromises = essentialsHandles.map(function(handle) {
        return self.getProductDataByHandle(handle);
      });

      return Promise.all(fetchPromises)
        .then(function(productDataArray) {
          //self.data.essentialProductData = productDataArray;
          self.data.essentialProductData = productDataArray.filter(function(productData) {
            return productData && productData.trim() !== "";
          });
          //return productDataArray;
          return self.data.essentialProductData;
        })
        .catch(function(error) {
          console.error('Error fetching product data:', error);
          return [];
        });
    },

    getProductDataByHandle: function(handle) {
      var self = this;

      return new Promise(function(resolve, reject) {
        // AJAX request to fetch the product data and HTML content of the essential product
        $.ajax({
          url: '/products/' + handle + '?view=essentials',
          success: function(data) {
            resolve(data);
          },
          error: function(XMLHttpRequest) {
            var errorDetails = {
              status: XMLHttpRequest.status,
              message: 'Error fetching product data',
              responseText: XMLHttpRequest.responseText
            };
            console.error('Error fetching product data:', errorDetails);
            reject(errorDetails);
          }
        });
      });
    },

    createSlider: function(slider) {
      var self = this;
      $(slider).flickity({ cellAlign: 'left',
        on: {
          ready: function() {
            var dotElements = document.querySelectorAll('.cart-essentials__wrapper .flickity-page-dots .dot');
            if (dotElements.length > 0) {
              var totalHandleItemCount = dotElements.length;
              var widthPercentage = 100 / totalHandleItemCount;
              dotElements.forEach(function(dotElement) {
                dotElement.style.width = 'calc(' + widthPercentage + '%)';
              });
            }
          }
        }
      });
      $(slider).flickity('resize');
    },

    addEssentialsToSlider: function() {
      var self = this;
      var essentialsWrapper = document.querySelector('.cart-essentials__wrapper');

      if (!essentialsWrapper) {
        return;
      }

      self.destroySlider(essentialsWrapper);
      essentialsWrapper.innerHTML = '';

      // HTML for each essential product item
      for (var i = 0; i < self.data.essentialProductData.length; i++) {
        var productData = self.data.essentialProductData[i];
        var productHtml = '<div class="slider-cell">' +
            productData +
            '</div>';

        essentialsWrapper.insertAdjacentHTML('beforeend', productHtml);
      }

      self.createSlider(essentialsWrapper);
    },

    destroySlider: function(slider) {
      var self = this;
      var flickityInstance = Flickity.data(slider);

      if (flickityInstance) {
        flickityInstance.destroy();
      }
    },

    updateEssentialsAndSlider: async function() {
      var self = this;

      try {
        // Wait for the essential product data to be fetched and updated
        await self.essentialProductDataPromise;
        // essentialProductData item as a slider cell
        self.addEssentialsToSlider();
      } catch (error) {
        console.error('Error updating essentials and slider:', error);
      }
    },

    checkFreeSeedPromo: function(cart){
      const self = this;

      if (!Shopify.theme.FreeSeedPromo){
        Shopify.theme.FreeSeedPromo = new window.odTheme.FreeSeedPromo(cart);
      }

      let freeSeedPromo = Shopify.theme.FreeSeedPromo.update(cart);

      self.data.freeSeedPromoEnabled = freeSeedPromo.data.displayInCart;
      self.data.seedCount = freeSeedPromo.data.seedCount;
      self.data.seedMaximum = freeSeedPromo.data.seedMaximum;

      var event = new CustomEvent("cart:freeSeedPromo", {
        detail: {
          freeSeedPromo: freeSeedPromo
        }
      });
      document.dispatchEvent(event);
    },

    addToCart: function(){
      let self = this;

      self.data.upsellAdded = true;

      // console.log("addToCart");
    },

    updateAccessEnabled: function(){ 
      const self = this;

      self.data.accessEnabled = {
        everyone: true,
        loggedOut: !window.odTheme.customer.loggedIn,
        loggedIn: window.odTheme.customer.loggedIn,
        notMember: !window.odTheme.customer.isMember,
        isMember: window.odTheme.customer.isMember || window.odTheme.customer.membershipInCart,
        expiringMember: window.odTheme.customer.isMember ? self.checkMembershipExpiration(window.odTheme.customer) : false,
        lapsedMember: !window.odTheme.customer.isMember && window.odTheme.customer.memberCode
      }
    },

    // checkMembershipExpiration: function(customer){
    //   const self = this;

    //   let expirationInSeconds = 0;
    //   let todaysDate = new Date();
    //   let expirationDate = null;

    //   for (let i = 0; i < customer.tags.length; i++) {
    //     if (customer.tags[i].indexOf(window.odTheme.prefixes.memberExpiry) > -1){
    //       let dateValue = customer.tags[i].replace(window.odTheme.prefixes.memberExpiry,'').trim();
    //       expirationDate = new Date(dateValue.split('/').reverse().join('/'));
    //     }
    //   }

    //   const oneDay = 24 * 60 * 60 * 1000;
    //   const daysLeft = Math.round(Math.abs((expirationDate - todaysDate) / oneDay));

    //   return daysLeft;
    // },
    checkMembershipExpiration: function() {
      let todaysDate = new Date();
      let expirationDateStr = window.odTheme.customer.member_expiry_date; // MM/DD/YYYY format
  
      if (!expirationDateStr) {
          //console.error("No expiry date found.");
          return null;
      }
  
      // Convert MM/DD/YYYY to YYYY-MM-DD for proper parsing
     // let parts = expirationDateStr.split('/');
      let expirationDate = new Date(expirationDateStr); // Month is zero-based
  
      // Calculate the difference in days
      const oneDay = 24 * 60 * 60 * 1000;
      let daysLeft = Math.round((expirationDate - todaysDate) / oneDay);
  
      return daysLeft;
  },

    removeProductFromCart: function(variantId){
      var self = this;
      var updates = {};
      updates[variantId] = 0;
      self.updateCart(updates);

      self.updateCart(updates).then(function() {
        self.getCart().then(function() {
          self.updateEssentialsAndSlider();
        });
      });
    },

    increaseQuantity: async function(variantId, quantity,item){
      var self = this;
      var updates = {};
      var newQuantity = quantity + 1;
      updates[variantId] = newQuantity;
      await self.updateCart(updates);
      item.loading = false;
    },

    decreaseQuantity: async function(variantId, quantity, item){
      var self = this;
      var updates = {};
      var newQuantity = quantity - 1;
      updates[variantId] = newQuantity;
      await self.updateCart(updates);
      item.loading = false;
    },

    updateCart: function(updates){
      var self = this;

      return new Promise(function(resolve, reject) {
        $.ajax({
          url: '/cart/update.js',
          method: 'POST',
          dataType: 'json',
          data: {
            updates: updates
          },
          success: function (data) {
            self.getCart();
            Shopify.theme.jsAjaxCart.blockMembershipATC();
          },
          error: function (XMLHttpRequest) {
            console.log('issue updating cart');
          }
        });
      });

    },

    checkIsMember: function(cart){
      var self = this;

      let membershipInCart = false;

      for (var i = 0; i < self.data.cart.items.length; i++) {
        var item = self.data.cart.items[i];
        if (item.product_type == window.odTheme.productTypes.membership){
          membershipInCart = true;
        }
      }

      if (membershipInCart){
        self.data.isMember = true;
        self.data.accessEnabled.isMember = true;
        window.odTheme.customer.membershipInCart = true;
        self.data.accessEnabled.notMember = false;
      } else {
        self.data.isMember = window.odTheme.customer.isMember;
        window.odTheme.customer.membershipInCart = false;
        self.data.accessEnabled.isMember = window.odTheme.customer.isMember;
        self.data.accessEnabled.notMember = !window.odTheme.customer.isMember && !window.odTheme.customer.membershipInCart;
      }
    },

    checkGifts: function(cart){
      const self = this;
      if (self.data.cartGifts && self.data.cartGifts.variant_id){
        let giftVariantId = self.data.cartGifts.variant_id;
        let giftMinSpend = parseInt(self.data.cartGifts.min_spend);

        if (self.data.isMember && cart.cart.memberPriceTotal > giftMinSpend){
          if (!self.checkIsInCart(cart,giftVariantId)){
            self.addGiftToCart(giftVariantId);
          }

        }
      }
    },

    checkIsInCart: function(cart,variantId){
      const self = this;
      let cartItems = cart.items.map((item)=>{
        return item.variant_id;
      });
      if (cartItems.indexOf(parseInt(variantId)) > -1){
        return true;
      }
      return false;
    },

    addGiftToCart: function(giftVariantId){
      const self = this;
      const quantity = 1;
      let properties = {
        '_is_free_gift': true,
        '_hide_quantity': true
      };

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: { items: [
            {
              id: giftVariantId,
              quantity: quantity,
              properties: properties
            }
          ]
        },
        beforeSend: function () {

        },
        success: function (product) {}
      });
    },

    getCart: async function() {
      var self = this;

      return new Promise(async function(resolve, reject) {
        try {
          var data = await $.ajax({
            url: '/cart?view=json'
          });

          // Bad data being added to the "Gift Membership" gift_message key and still stuck in some people's carts.
          data = data.replace(
            /("gift_message"\s*:\s*")([\s\S]*?)(")/g,
            (_, start, value, end) =>
              start + value.replace(/[\r\n\u2028\u2029\u0085]+/g, '\\n') + end
          );

          // Bad data being added to the "Gift Card Membership" Message key  still stuck in some people's carts.
          // Note I have not worked out how the value gets added yet, so any multi-line submission can still fail the cart.
          data = data.replace(
            /("Message"\s*:\s*")([\s\S]*?)(")/g,
            (_, start, value, end) =>
              start + value.replace(/[\r\n\u2028\u2029\u0085]+/g, '\\n') + end
          );          

          let cart = null;
          try {
            cart = JSON.parse(data);
            // console.log('success parsing cart');
            // console.log(cart);
          } catch (e) {
            console.error('Cart JSON parse failed', {
              error: e.message,
              dataSnippet: data?.slice(0, 500)
            });
          }

          if (cart) {
            var essentialsHandles = [];
            for (const item of cart.items) {
              if (item.essentials_data) {
                const handles = item.essentials_data.split(',');
                essentialsHandles.push(...handles);
              }
            }
            self.data.essentials = essentialsHandles;

            self.parseItemData(cart);
            self.checkIsMember(cart);
            self.checkUpsells(cart);
            self.loadUpsellProducts(cart);
            await self.fetchProductData();
            self.updateEssentialsAndSlider();
            self.displayCallToActions();
            self.checkGifts(cart);

            if (window.odTheme.customer['enable-free-seed-promo']) {
              self.checkFreeSeedPromo(cart);
            }
            if (window.odTheme.customer['promotion']['enabled']) {
              self.checkRenewalPromotion(cart);
            }
          }

          resolve();
        } catch (error) {
          resolve();
        }
      });
    },

    checkRenewalPromotion: function(cart){
      const self = this;

      if (!Shopify.theme.RenewalPromotion){
        Shopify.theme.RenewalPromotion = new window.odTheme.RenewalPromotion(cart);
      }

      let RenewalPromotion = Shopify.theme.RenewalPromotion.update(cart);

      self.data.renewalPromotionEnabled = RenewalPromotion.data.displayInCart;
      self.data.renewalProductCount = RenewalPromotion.data.renewalProductCount;
      self.data.renewalProductMaximum = RenewalPromotion.data.renewalProductMaximum;

      if (self.data.renewalPromotionEnabled){
        var checkoutForm = document.querySelector('form.Drawer__Content');
        var input = document.createElement("INPUT");
        input.classList.add('js-form-discount');
        input.type = 'hidden';
        input.name = 'discount';
        input.value = window.odTheme.customer.promotion.renewal_discount_Code;
        checkoutForm.append(input);
      }
      else {
        var checkoutDiscountCode = document.querySelector('form.Drawer__Content .js-form-discount');
        if (checkoutDiscountCode){
          checkoutDiscountCode.remove();
        }
      }

      var event = new CustomEvent("cart:RenewalPromotion", {
        detail: {
          RenewalPromotion: RenewalPromotion
        }
      });
      document.dispatchEvent(event);
    },

    displayCallToActions: function(){
      let self = this;

      if (self.data.cartCallToActions.length > 0){
        let lastActionIndex = self.data.cartCallToActions.length - 1;
        self.data.cartCallToAction = self.data.cartCallToActions[lastActionIndex];
        self.data.displayCallToActions = true;
      }

    },

    checkUpsells: function(cart){
      const self = this;

      self.data.cartUpsellsData.forEach((item)=>{
        let qualifies = false;


        let storageObj = sessionStorage.getItem(item.id);
        if (storageObj != null) {
          let currentTime = new Date().getTime();
          let storageData = JSON.parse(storageObj);
          let storageExpirationTime = storageData.timestamp;
          if (storageExpirationTime > currentTime) {
            return;
          }
          sessionStorage.removeItem(item.id);
        }


        if (self.data.accessEnabled[item.display_rule]){
          qualifies = true;

          if (item.display_rule.includes('expir')){
            qualifies = false;
            if (item.expiration_day_count && item.expiration_day_count > self.data.accessEnabled[item.display_rule]){
              qualifies = true;
            }
          }
          if (item.display_rule.includes('lap')){
            qualifies = false;
            if (self.data.accessEnabled[item.display_rule]){
              qualifies = true;
            }
          }
        }

        if (qualifies){
          if (item.type == 'call_to_action'){
            item = self.parseStringVariables(item,cart);
            self.data.cartCallToActions.push(item);
          }

          self.data.cartUpsells.push(item);

        }
      });
    },

    validateIfAlreadyInCart: function(cart) {
      const self = this;

      if (
          self.data.cartUpsells &&
          Array.isArray(self.data.cartUpsells) &&
          cart &&
          cart.items &&
          Array.isArray(cart.items)
      ) {
        let cartItems = cart.items.map((item) => {
          return item.id;
        });

        self.data.cartUpsells = self.data.cartUpsells.filter((item) => {
          let upsellNotInCart = true;
          if (item.type == "cart_upsell") {
            if (item.products && Array.isArray(item.products)) { // Check if item.products exists
              for (var i = 0; i < item.products.length; i++) {
                if (cartItems.indexOf(item.products[i].variant_id) > -1) {
                  upsellNotInCart = false;
                  break;
                }
              }
            }
          }
          return upsellNotInCart;
        });
      }
    },

    parseStringVariables(cartUpsell,cart){
      const self = this;

      var memberPriceTotal = 0;
      var variantPriceTotal = 0;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        variantPriceTotal += item.original_price * item.quantity;
        //console.log("variantPriceTotal:", variantPriceTotal , "item.member_price_metafield", item.member_price_metafield)
        memberPriceTotal += (item.line_price == 0 ? item.line_price : item.member_price_metafield * item.quantity);
        //console.log("memberPriceTotal", memberPriceTotal)
      }
      

      cartUpsell.title = cartUpsell.title.split('[amount]').join(Shopify.formatMoney(variantPriceTotal - memberPriceTotal));

      return cartUpsell;
    },

    selectUpsellProduct: function(selectedVariant,upsell){
      var self = this;

      for (var i = 0; i < upsell.products.length; i++) {
        var product = upsell.products[i];
        if (product.variant_id == selectedVariant){
          upsell.selected = product;
        }
      }
    },

    loadUpsellProducts: async function(cart){
      var self = this;
      var batchArray = [];

      self.data.cartUpsells.forEach((item)=>{
        var handle = item.handle;
        let tag = '';

        if (item.use_tag && item.tag && item.tag.length > 0){
          tag = encodeURIComponent(item.tag.split(' ').join(''));
        }

        if (handle && handle.length > 0){
          batchArray.push(self.loadCollection(handle,item,tag));
        }
      });

      await Promise.all(batchArray).then(function() {
        self.validateIfAlreadyInCart(cart);
        self.displayUpsell();
      }).catch(function(error) {
        console.log(error);
      });
    },

    displayUpsell: function(){
      var self = this;

      let lastUpsellIndex = self.data.cartUpsells.length - 1;
      self.data.cartUpsell = self.data.cartUpsells[lastUpsellIndex];
      self.data.displayUpsell = true;

      // Make sure to select the appropriate select element based on your HTML structure
      var selectElements = document.querySelectorAll(".custom-select select");
      for (var i = 0; i < selectElements.length; i++) {
        var selElmnt = selectElements[i];
        var x, i, j, l, ll, selElmnt, a, b, c;
        /* Look for any elements with the class "custom-select": */
        x = document.getElementsByClassName("custom-select");
        l = x.length;
        for (i = 0; i < l; i++) {
          selElmnt = x[i].getElementsByTagName("select")[0];
          ll = selElmnt.length;
          // Check if a "select-selected" element already exists
          let existingSelectSelected = x[i].getElementsByClassName("select-selected")[0];
          // If it exists, update its content
          if (existingSelectSelected) {
            existingSelectSelected.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
          } else {
            /* For each element, create a new DIV that will act as the selected item: */
            a = document.createElement("DIV");
            a.setAttribute("class", "select-selected");
            a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
            x[i].appendChild(a);
            /* For each element, create a new DIV that will contain the option list: */
            b = document.createElement("DIV");
            b.setAttribute("class", "select-items select-hide");
            for (j = 1; j < ll; j++) {
              /* For each option in the original select element,
              create a new DIV that will act as an option item: */
              c = document.createElement("DIV");
              c.innerHTML = selElmnt.options[j].innerHTML;
              c.addEventListener("click", function(e) {
                /* When an item is clicked, update the original select box,
                and the selected item: */
                var y, i, k, s, h, sl, yl;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];

                sl = s.length;
                h = this.parentNode.previousSibling;
                for (i = 0; i < sl; i++) {
                  if (s.options[i].innerHTML == this.innerHTML) {
                    s.selectedIndex = i;
                    h.innerHTML = this.innerHTML;
                    y = this.parentNode.getElementsByClassName("same-as-selected");
                    yl = y.length;
                    for (k = 0; k < yl; k++) {
                      y[k].removeAttribute("class");
                    }
                    this.setAttribute("class", "same-as-selected");
                    break;
                  }
                }
                // h.click();
                // Dispatch the change event on the select element
                var event = new Event('change');
                s.dispatchEvent(event);
              });
              b.appendChild(c);
            }
            x[i].appendChild(b);
            a.addEventListener("click", function(e) {
              /* When the select box is clicked, close any other select boxes,
              and open/close the current select box: */
              e.stopPropagation();
              closeAllSelect(this);
              this.nextSibling.classList.toggle("select-hide");
              this.classList.toggle("select-arrow-active");
            });
          }
        }
      }

      function closeAllSelect(elmnt) {
        /* A function that will close all select boxes in the document,
        except the current select box: */
        var x, y, i, xl, yl, arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        xl = x.length;
        yl = y.length;
        for (i = 0; i < yl; i++) {
          if (elmnt == y[i]) {
            arrNo.push(i)
          } else {
            y[i].classList.remove("select-arrow-active");
          }
        }
        for (i = 0; i < xl; i++) {
          if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
          }
        }
      }

      /* If the user clicks anywhere outside the select box,
      then close all select boxes: */
      document.addEventListener("click", closeAllSelect);

    },

    loadCollection: async function(handle, upsell, tag){
      var self = this;
      return new Promise(function(resolve, reject) {

        let url = '/collections/'+ handle +'?view=json';
        if (tag.length > 0){
          url = '/collections/'+ handle + '/' + tag + '?view=json';
        }

        $.ajax({
          url: url,
          success: function (data) {

            var products = JSON.parse(data);
            if (products.length > 0){
              upsell.products = products.splice(0,10);
              upsell.selected = upsell.products[0];
            }

            return resolve();

          },
          error: function (XMLHttpRequest) {
            return resolve();
          }
        });

      });
    },

    parseItemData: function(data){
      //console.log("here DATA", data)
      let self = this;
      self.data.cart = data.cart;
      self.data.cart.items = [];
      let memberPriceTotal = 0;
      let memberPriceTaxable = 0;
      let priceTaxable = 0;

      for (let i = 0; i < data.items.length; i++) {
        var item = data.items[i];
       
        // Convert properties object into an array of key-value pairs
        if (item.properties) {
          item.propertyArray = Object.keys(item.properties).map(function(key) {
            return {
              key: key,
              value: item.properties[key]
            };
          });
        } else {
          item.propertyArray = [];
        }
        self.data.cart.items.push(item);
        memberPriceTotal += item.member_price_metafield * item.quantity;

        if (item.taxable){
          memberPriceTaxable += item.member_price_metafield * item.quantity;
          priceTaxable += item.price * item.quantity;
        }
      }

      self.data.cart.memberPriceTaxable = memberPriceTaxable;
      self.data.cart.priceTaxable = priceTaxable;
      self.data.cart.memberPriceTotal = memberPriceTotal;
      self.data.memberSaves = self.data.cart.total_price - self.data.cart.memberPriceTotal;
  

    },

    initAccordion: function (){
      const holders = document.querySelectorAll(this.data.cartWidget);

      // remove comment if need close state for recommended product
      // and for .related-product-wrapper .cart_essential_items add display: none;

      // const essentialsWrapper = document.querySelector('.cart-essentials__wrapper');

      // this.destroySlider(essentialsWrapper);

      holders.forEach(holder => {
        const expandButtons = holder.querySelectorAll(this.data.clickedElementForExpanding);

        expandButtons.forEach(button => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            const holder = button.parentElement.querySelector('.cart_essential_items');
            button.classList.toggle(this.data.closeClass);
            this.slideToggle(holder, 400);

            if (holders.length > 1) {
              holders.forEach(content => {
                if (content !== holder.parentElement) {
                  const buttonExpand = content.querySelector(this.data.clickedElementForExpanding);
                  buttonExpand.classList.remove(this.data.closeClass);
                  this.slideUp(buttonExpand.nextElementSibling, 400);
                }
              });
            }
          });
        });
      });
    },

    slideToggle: function (target, duration, showDisplay = 'block') {
      if (window.getComputedStyle(target).display === 'none') {
        return this.slideDown(target, duration, showDisplay);
      } else {
        return this.slideUp(target, duration);
      }
    },

    slideDown: function (target, duration, showDisplay = 'block', checkHidden = true) {
      let display = window.getComputedStyle(target).display;
      if (checkHidden && display !== 'none') {
        return;
      }
      target.style.removeProperty('display');
      if (display === 'none') display = showDisplay;
      target.style.display = display;
      let height = target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      target.offsetHeight;
      target.style.boxSizing = 'border-box';
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.height = height + 'px';
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      window.setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
      }, duration);

      // remove comment if need close state for recommended product
      // and for .related-product-wrapper .cart_essential_items add display: none;
      // const essentialsWrapper = document.querySelector('.cart-essentials__wrapper');

      // this.createSlider(essentialsWrapper);
    },

    slideUp: function (target, duration) {
      target.style.transitionProperty = 'height, margin, padding';
      target.style.transitionDuration = duration + 'ms';
      target.style.boxSizing = 'border-box';
      target.style.height = target.offsetHeight + 'px';
      target.offsetHeight;
      target.style.overflow = 'hidden';
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;
      window.setTimeout(() => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
      }, duration);
    }
  });

  return AjaxCart;
})();

document.addEventListener("DOMContentLoaded", function(event) {

  var productTabsContainer = document.querySelector('[data-cart-view]');
  if (productTabsContainer){
    new window.odTheme.AjaxCart(productTabsContainer);
  }

  const productsATC2 = document.querySelectorAll('[data-pf-type="ProductATC2"]');
  productsATC2.forEach(function(productATC2) {
    productATC2.addEventListener('click', function(e) {
      productsATC2.forEach(function(productATC2) {
        productATC2.disabled = true;
        productATC2.classList.add('disabled');
      });
      setTimeout(function() {
        Shopify.theme.jsAjaxCart.blockMembershipATC();
      }, 2000);
    });
  });
});